/** Réglages des fonds du thème Rythme (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "Le « tempo » du fond : ×1 est la vitesse d'origine.",
    },
    nombre: {
        type: "nombre", libelle: "Nombre d'éléments", min: 4, max: 24, pas: 1, defaut: 12,
        aide: "Notes, barres ou faisceaux selon le fond (24 au plus, pour garder l'écran léger).",
    },
    palette: {
        type: "choix", libelle: "Palette", defaut: "pop",
        options: [{valeur: "pop", libelle: "Pop (turquoise et rose)"}, {valeur: "nuit", libelle: "Nuit (violet et or)"}, {valeur: "soleil", libelle: "Soleil (orange et jaune)"}],
    },
};

/** Couleurs de chaque palette : fond haut, fond bas, quatre couleurs vives (une par piste). */
export const PALETTES = {
    pop: {haut: "#061a2e", bas: "#0e3a5c", vives: ["#2ee6d6", "#ff5fa8", "#ffe14d", "#8f7bff"]},
    nuit: {haut: "#0b0620", bas: "#2a1055", vives: ["#b48bff", "#ffd24a", "#ff6fb5", "#6fd0ff"]},
    soleil: {haut: "#2a0f05", bas: "#5c2a0a", vives: ["#ffb13b", "#ffe14d", "#ff6a3d", "#fff3b0"]},
};
